<template>
  <div class="row ml-0 mb-4" v-if="canShowService">
    <SectionTitle content="Estatus del Servicio" :has-line="true" />
    <row v-for="(service, index) in services" :key="index" :item="service" />
  </div>
</template>

<script>
import { SectionTitle } from "@/components/pei/shared";
import Row from "@/components/pei/service/components/ServiceStatusRow";
export default {
  components: { SectionTitle, Row },
  props: {
    services: { type: Array, required: true, default: () => [] }
  },
  computed: {
    canShowService() {
      return this.services && this.services.length > 0;
    }
  }
};
</script>

<style></style>
